module.exports = __webpack_public_path__ + "img/TR.0fcb039c.svg";